import { useEffect } from 'react'
import { useSelector } from 'react-redux'

import { createNotification } from '@/app/module/notifications/store/actions'
import { ERROR_GET_RECEIPTS_SERVER } from '@/app/module/payments/definitions'
import { selectOrgId } from '@/app/module/user/store/selectors'
import { esApi } from '@/app/store/api'
import { useAppDispatch } from '@/app/store/redux-hooks'

export const useGetReceipts = () => {
  const dispatch = useAppDispatch()
  const orgId = useSelector(selectOrgId)
  const res = esApi.endpoints.getOrgPurchaseList.useQuery({ orgId: orgId.toString() })

  useEffect(() => {
    if (!res.error) {
      return
    }
    dispatch(
      createNotification({
        'get-receipts': {
          type: 'error',
          message: ERROR_GET_RECEIPTS_SERVER,
        },
      }),
    )
  }, [res.error, dispatch])

  return res
}
